import React from "react";

export default () => <span className="required-icon">*</span>
